// client/src/components/FeatureFlagsPage.js

import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import AppBarHeader from './AppBarHeader';
import AdminFeatureFlags from './AdminFeatureFlags';

/**
 * Dedicated page for managing feature flags
 */
const FeatureFlagsPage = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const user = token ? jwtDecode(token) : null;
  const userId = user ? user.id : null;
  const isAdmin = user ? user.isAdmin : false;

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div>
      <AppBarHeader 
        isAdmin={isAdmin} 
        userId={userId} 
        onLogout={handleLogout}
      />
      <Button
        variant="outlined"
        onClick={() => navigate('/admin')}
        sx={{ mb: 2, ml: 2 }}
      >
        ← Back to Admin Dashboard
      </Button>
      <Container maxWidth="md">
        <Box sx={{ mt: 4, mb: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Feature Flags Management
          </Typography>
          <Typography variant="body1" paragraph align="center" color="text.secondary">
            Enable or disable features across the application.
          </Typography>
          
          <Box sx={{ mt: 4 }}>
            <AdminFeatureFlags />
          </Box>
        </Box>
      </Container>
    </div>
  );
};

export default FeatureFlagsPage;
